export default "__VITE_ASSET__9002f59c__"